<template>
  <div class="other-nat-report-detail">
    <ph-empty
      v-if="!projectResult"
      bgcolor="white"
      content="您的核酸报告暂未生成"
    />
    <div style="color: white !important;background: #72b8fc;">
      <div class="other-nat-report-detail-info other-nat-report-detail-content">
        <div>
          <div>龙岩人民医院</div>
          <div>{{ projectName }}</div>
          <div>{{ name }} {{ cardNo }}</div>
          <div>{{ date }}</div>
        </div>
        <img
          :src="require('@assets/icon_hospital.png')"
          style="border-radius: 50%;"
          alt=""
        />
      </div>
      <!-- <div style="height: .5rem;background: #f4f4f4;"></div> -->
      <div class="other-nat-report-detail-content">
        <div>{{ projectName }}</div>
        <div>参考值： {{ referenceValue }}</div>
      </div>
    </div>
    <div class="other-nat-report-detail-content">
      <span>结果值：</span><span>{{ projectResult }}</span>
    </div>
    <VueBarcode :value="barcode" class="other-nat-report-detail-barcode">
      {{ barcode }}
    </VueBarcode>
    <!-- <div class="other-nat-report-detail-tips">
      <h4>温馨提示</h4>
      <div>
        如需打印纸质报告，请根据此条码前往医院现场打印纸质报告！
      </div>
    </div> -->
  </div>
</template>

<script>
import VueBarcode from "vue-barcode";

export default {
  components: { VueBarcode },
  data() {
    return {
      name: "",
      projectName: "",
      projectResult: "",
      cardNo: "",
      date: "",
      id: "",
      referenceValue: "",
      barcode: ""
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.loadData();
  },
  methods: {
    loadData() {
      this.$http
        .post(this.$api.TEST_GET_BGCX, {
          yjdjh: this.id
        })
        .then(data => {
          // const data = res
          this.name = data.name;
          this.projectName = data.BGXMMC;
          this.projectResult = data.BGJYJG;
          this.cardNo = data.cardNo;
          this.date = data.CBGRQ0;
          this.referenceValue = data.CKFW00;
          this.barcode = data.cardNo;
        });
    }
  }
};
</script>

<style lang="less">
.other-nat-report-detail {
  font-size: 0.9rem;

  &-content {
    padding: 0.5rem 1rem;
    font-weight: 500;
  }

  &-info {
    display: flex;
    justify-content: space-between;

    img {
      width: 4rem;
      height: 4rem;
      margin-top: 0.5rem;
    }
  }

  &-barcode {
    margin-top: 1rem;
    svg {
      width: 100%;
    }
  }

  &-tips {
    padding: 0 1rem;
  }
}
</style>
